import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { isPowercloudCommunicationDebugAvailable } from '@/lib/powercloudCommunicationDebug';
import { DebugConfig } from './Debug/DebugConfig';

import { DokumentTypenConfig } from './DokumentTypen/DokumentTypenConfig';
import { StreamServeConfig } from './StreamServe/StreamServeConfig';

type configurationTabs = 'dokumenttypen' | 'streamserve' | 'debug';

interface KonfigurationPageProps {
  initialActiveTab: configurationTabs;
}

const TAB_ROUTES: Record<configurationTabs, string> = {
  dokumenttypen: '/konfiguration/dokumenttypen',
  streamserve: '/konfiguration/streamserve',
  debug: '/konfiguration/debug',
};

const tabClass = (active: boolean) =>
  `${
    active
      ? 'border-primary text-text-primary'
      : 'border-transparent text-text-muted hover:text-text-primary'
  }`;

export const KonfigurationPage: React.FC<KonfigurationPageProps> = ({
  initialActiveTab,
}) => {
  const navigate = useNavigate();

  // The active tab is derived from the route (via initialActiveTab), so browser
  // history/URLs work; clicking a tab navigates to its route.
  const activeTab = initialActiveTab;
  const debugAvailable = isPowercloudCommunicationDebugAvailable(
    import.meta.env.MODE,
  );

  if (activeTab === 'debug' && !debugAvailable) {
    return <Navigate to={TAB_ROUTES.dokumenttypen} replace />;
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between pt-3">
        <h1 className="text-2xl font-bold text-text-primary">Konfiguration</h1>
      </div>

      <div className="bg-white border border-table-border rounded-lg p-4">
        <div className="flex gap-4">
          <Button
            variant="ghost"
            size="sm"
            className={tabClass(activeTab === 'dokumenttypen')}
            onClick={() => navigate(TAB_ROUTES.dokumenttypen)}
          >
            Dokumenttypen
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className={tabClass(activeTab === 'streamserve')}
            onClick={() => navigate(TAB_ROUTES.streamserve)}
          >
            StreamServe
          </Button>
          {debugAvailable && (
            <Button
              variant="ghost"
              size="sm"
              className={tabClass(activeTab === 'debug')}
              onClick={() => navigate(TAB_ROUTES.debug)}
            >
              Debug
            </Button>
          )}
        </div>
      </div>

      <div>
        {activeTab === 'dokumenttypen' && <DokumentTypenConfig />}
        {activeTab === 'streamserve' && <StreamServeConfig />}
        {activeTab === 'debug' && debugAvailable && <DebugConfig />}
      </div>
    </div>
  );
};
